import { Box, Typography, Stack, Switch } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 36,
  height: 20,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: 16,
    height: 16,
  },
  "& .MuiSwitch-track": {
    borderRadius: 10,
    backgroundColor: "#cbd5e1",
    opacity: 0.9,
  },
}));

export default function ToggleSection({ title, items, values, onToggle }) {
  return (
    <Box>
      <Typography
        sx={{
          fontSize: 15,
          fontWeight: 700,
          color: "#1e293b",
          mb: 2,
        }}
      >
        {title}
      </Typography>

      <Stack spacing={0}>
        {items.map((item, i) => (
          <Row
            key={item.key}
            label={item.label}
            checked={values[item.key]}
            onChange={() => onToggle(item.key)}
            isLast={i === items.length - 1}
          />
        ))}
      </Stack>
    </Box>
  );
}

function Row({ label, checked, onChange, isLast }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        py: 1.3,
        px: 0,
        borderBottom: isLast ? "none" : "1px solid #f1f5f9",
      }}
    >
      <Typography sx={{ fontSize: 13, fontWeight: 500, color: "#334155" }}>
        {label}
      </Typography>
      <CustomSwitch checked={checked} onChange={onChange} />
    </Box>
  );
}
